import React, { Component } from 'react'
import { i18nTranslate } from 'src/utils'
import { Button, Modal } from 'react-bootstrap'
import './styles.scss'

class NotificationErrorPopup extends Component {
  constructor(props) {
    super(props)
  }
  render() {
    const {
      isToShowPopUp = true,
      handleCloseNotificationErrorPopup,
      errorMessges,
    } = this.props

    return (
      <Modal
        show={isToShowPopUp}
        className="conversion-success-modal rounded-md">
        <Modal.Body className="conversion-success-modal">
          <h4 className="conversion-success-modal-title">
            {i18nTranslate(
              'ba_to_member_membership_switch_error',
              'You are not eligible to Switch to Member.'
            )}
          </h4>
          <div data-testid="error-meessage" className="small mt-3">
            {errorMessges?.length > 0 &&
              errorMessges?.map((msg, index) => (
                <div className="ssmall mb-2" key={index}>
                  {msg}
                </div>
              ))}
          </div>
          <div className="row">
            <div className="col-12">
              <Button
                data-testid="qa-acknowledgeButton"
                className="acknowledge-button rounded-md"
                variant="primary"
                type="submit"
                onClick={handleCloseNotificationErrorPopup}
                block>
                {i18nTranslate('ba_to_member_i_understand', 'I understand')}
              </Button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    )
  }
}

export default NotificationErrorPopup
export { NotificationErrorPopup }
